module.exports = __webpack_public_path__ + "img/Poorter_hotel-279.94383b48.jpg";